module.exports = __webpack_public_path__ + "media/images/menu-70649755af8e7fe6cde576a7898a4721.svg";